/* eslint-disable react/prop-types */
import './App.css'

import {
  // BraintreeSubscriptionPage,
  CollectionTranslations,
  // MassUpdater,
  VendorAnalytics,
  VendorAnalyticsAudience,
  VendorAnalyticsSales,
  VendorDashboard,
  VendorOrderDetail
  // VendorSubscription
} from 'pages'
import forgotPassword from 'pages/forgot-password'
import SapOrders from 'pages/SapOrders'
import { shape } from 'prop-types'
import { string } from 'prop-types'
import { func } from 'prop-types'
import { bool } from 'prop-types'
import React, { Component, useEffect } from 'react'
import cookies from 'react-cookies'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  withRouter
} from 'react-router-dom'
import { useRouteMatch } from 'react-router-dom'
import { LogOut } from 'redux/actions/users-action'
import { getUserType } from 'utils/auth'
import { COOKIES, USER_TYPES } from 'utils/constants'
import { isExpired } from 'utils/utils'

import Header from './components/header/header'
import Loading from './components/loading/loading'
import messages from './messages'
import Admin from './pages/admin'
// import ApprovalDetail from './pages/approval-detail'
import ApproverDashboard from './pages/approver-dashboard'
import ApproverWorkflow from './pages/approver-workflow'
import CollectionsForManager from './pages/collections-for-manager'
import CompanyBio from './pages/company-bio'
// import ExportPreview from './pages/export-preview'
// import ImageAssets from './pages/image-assets'
import Login from './pages/login'
// import Merchandising from './pages/merchandising'
import Onboarding from './pages/onboarding'
// import OnboardingFlowUi3 from './pages/onboarding-flow-UI3'
import PageNotFound from './pages/page-not-fount'
// import Pricing from './pages/pricing'
// import ProductDataTypes from './pages/product-data-types'
import PromoteUi from './pages/promote-ui'
import ResetPassword from './pages/reset-password'
import TranslatorDashboard from './pages/translator-dashboard'
import TranslatorProduct from './pages/translator-product'
// import Vendor from './pages/vendor'
import VendorBio from './pages/vendor-bio'
// import VendorCollectionList from './pages/vendor-collection-list'
import VendorContact from './pages/vendor-contact'

const RedirectRoute = ({ to, ...rest }) => {
  const match = useRouteMatch(rest.path)

  useEffect(() => {
    if (match) {
      let redirectTo = to

      Object.keys(match.params).forEach((param) => {
        const paramValue = match.params[param]
        redirectTo = redirectTo.replace(`:${param}`, paramValue)
      })

      window.location.href = redirectTo
    }
  }, [match, to])

  return null
}

class App extends Component {
  collectionTranslationsHd = (config = {}) => {
    const { collectionName, formatMessage } = config || {}
    const t1 = formatMessage({ id: 'Translations for' })

    return `${t1} ${collectionName}`
  }

  render() {
    const { authReducer, lang, LogOut } = this.props

    const PrivateRoute = ({
      allowedUserTypes = [],
      component: Component,
      forbiddenUserTypes = [],
      redirectPath = '/',
      ...rest
    }) => {
      const { authorized } = authReducer
      const cookieAuth = cookies.load(COOKIES.AUTH)
      const userType = getUserType(authReducer)
      const inAllowedUT = allowedUserTypes.indexOf(userType) > -1
      const inForbiddenUT = forbiddenUserTypes.indexOf(userType) > -1
      let allowRoute = authorized

      if (allowedUserTypes.length > 0) {
        allowRoute = authorized && inAllowedUT
      }
      if (forbiddenUserTypes.length > 0) {
        allowRoute = authorized && !inForbiddenUT
      }

      const isTokenExpired = isExpired(authReducer.user.exp || 0)

      return (
        <Route
          {...rest}
          render={(props) => {
            if (isTokenExpired) {
              cookies.remove(COOKIES.AUTH)
              return (
                <Redirect
                  to={{
                    pathname: cookieAuth ? redirectPath : '/',
                    state: { from: props.location }
                  }}
                />
              )
            }

            if (!cookieAuth && authorized) {
              LogOut()
            }

            return allowRoute && cookieAuth ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: cookieAuth ? redirectPath : '/',
                  state: { from: props.location }
                }}
              />
            )
          }}
        />
      )
    }

    const MainRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={(props) => {
          const cookieAuth = cookies.load(COOKIES.AUTH)
          let url = '/'

          if (authReducer.user) {
            url = authReducer.user.url
          }
          return !authReducer.authorized || !cookieAuth ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: url,
                state: { from: props.location }
              }}
            />
          )
        }}
      />
    )
    return (
      <IntlProvider locale={lang} messages={messages[lang]}>
        <div className="App">
          <BrowserRouter>
            <Header />
            <Switch>
              <MainRoute exact path="/" component={Login} />
              <Route exact path="/forgot-password" component={forgotPassword} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/loading" component={() => <Loading show />} />
              <PrivateRoute path="/admin" component={Admin} />
              <PrivateRoute
                component={ApproverWorkflow}
                forbiddenUserTypes={[USER_TYPES.VENDOR]}
                path="/approval-dashboard/:id?"
              />
              <RedirectRoute
                // allowedUserTypes={[USER_TYPES.ADMIN, USER_TYPES.LOGISTICS]}
                // component={MassUpdater}
                path="/mass-updater"
                to="/mass-updater"
              />
              <PrivateRoute
                component={Onboarding}
                forbiddenUserTypes={[USER_TYPES.APPROVER, USER_TYPES.VENDOR]}
                path="/onboarding/:id?"
              />
              <RedirectRoute
                exact
                // component={Vendor}
                // forbiddenUserTypes={[USER_TYPES.VENDOR]}
                path="/vendor/:id"
                to="/onboarding/:id"
              />
              <PrivateRoute
                exact
                component={VendorAnalytics}
                path="/vendor/:id/analytics"
              />
              <PrivateRoute
                component={VendorAnalyticsAudience}
                path="/vendor/:id/analytics/audience"
              />
              <PrivateRoute
                component={VendorAnalyticsSales}
                path="/vendor/:id/analytics/sales"
              />
              <RedirectRoute
                // component={ProductDataTypes}
                // forbiddenUserTypes={[USER_TYPES.VENDOR]}
                path="/product-data-types"
                to="/custom-properties"
              />
              <PrivateRoute
                exact
                component={TranslatorDashboard}
                forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/translator-dashboard/:translator"
              />
              <RedirectRoute
                // component={CollectionTranslations}
                // forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/translator-dashboard/:translator/:collectionId"
                to="/collections/:collectionId/bulk"
              />
              <PrivateRoute
                component={CompanyBio}
                forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/company-bio/:collection/:vendor"
              />
              <RedirectRoute
                component={(props) => (
                  <CollectionTranslations
                    {...props}
                    makeHeading={this.collectionTranslationsHd}
                  />
                )}
                path="/translate-collection/:collectionId"
                to="/collections/:collectionId/bulk"
              />
              <PrivateRoute
                component={TranslatorProduct}
                forbiddenUserTypes={[
                  USER_TYPES.APPROVER,
                  USER_TYPES.BUYER,
                  USER_TYPES.VENDOR
                ]}
                path="/translate-product/:product"
              />
              <RedirectRoute
                // component={OnboardingFlowUi3}
                // forbiddenUserTypes={[USER_TYPES.VENDOR]}
                path="/onboarding-ui3/:collection"
                to="/collections/:collection"
              />
              <PrivateRoute
                component={VendorBio}
                path="/vendor-bio/:vendorId"
              />
              <PrivateRoute path="/promote/:vendor" component={PromoteUi} />
              <PrivateRoute
                path="/vendor-contact/:vendor"
                component={VendorContact}
              />
              <RedirectRoute
                // component={VendorSubscription}
                path="/vendor-subscription/:vendorId"
                to="/vendor-subscription/:vendorId"
              />
              <RedirectRoute
                // component={VendorCollectionList}
                // forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/collection-list/:owner/:vendor/:collection"
                to="/vendors/:vendor/collections"
              />
              <RedirectRoute
                // component={ExportPreview}
                // forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/export-preview/:collection"
                to="/collections/:collection"
              />
              <RedirectRoute
                exact
                path="/product-detail/:product"
                to="/products/:product"
                // component={ProductDetail}
              />
              <RedirectRoute
                // component={ImageAssets}
                // forbiddenUserTypes={[
                //   USER_TYPES.BUYER,
                //   USER_TYPES.TRANSLATOR,
                //   USER_TYPES.VENDOR
                // ]}
                path="/image-assets/:owner/:vendor"
                to="/vendors/:vendor/collections"
              />
              <RedirectRoute
                // allowedUserTypes={[
                //   USER_TYPES.ADMIN,
                //   USER_TYPES.APPROVER,
                //   USER_TYPES.LOGISTICS
                // ]}
                path="/approval-detail/:collection"
                to="/collections/:collection"
                // component={ApprovalDetail}
              />
              <PrivateRoute
                allowedUserTypes={[
                  USER_TYPES.ADMIN,
                  USER_TYPES.APPROVER,
                  USER_TYPES.LOGISTICS
                ]}
                component={ApproverDashboard}
                path="/approver-dashboard/:approver"
              />
              <PrivateRoute
                component={ApproverWorkflow}
                forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/approver-workflow/:approver"
              />
              <PrivateRoute
                exact
                path="/vendor-dashboard/:vendor"
                component={VendorDashboard}
              />
              <PrivateRoute
                path="/vendors/:vendor/orders_old/:orderNumber"
                component={VendorOrderDetail}
              />
              <RedirectRoute
                // component={Pricing}
                // forbiddenUserTypes={[USER_TYPES.BUYER, USER_TYPES.VENDOR]}
                path="/pricing/:owner/:vendor/:collection"
                to="/collections/:collection"
              />
              <RedirectRoute
                // component={Merchandising}
                path="/merchandising/:vendor"
                to="/vendors/:vendor/catalog"
              />
              <PrivateRoute
                path="/collections-for-manager/:owner/:vendor"
                component={CollectionsForManager}
              />
              <RedirectRoute
                // component={BraintreeSubscriptionPage}
                path="/vendor-plans/:vendorId"
                to="/vendor-plans/:vendorId"
              />
              <PrivateRoute
                path="/sap/orders"
                component={SapOrders}
                forbiddenUserTypes={[USER_TYPES.VENDOR]}
              />
              <RedirectRoute
                path="/order-list/:vendor"
                to="/vendors/:vendor/orders"
              />
              <RedirectRoute
                path="/order-list/:vendor/:orderNumber"
                to="/vendors/:vendor/orders/:orderNumber"
              />
              {/* START: RULES TO FORWARD URLS TO NEW APPLICATION BEFORE 404 */}
              <RedirectRoute
                path="/vendors/:vendor/collections"
                to="/vendors/:vendor/collections"
              />
              <RedirectRoute
                path="/vendors/:vendor/catalog"
                to="/vendors/:vendor/catalog"
              />
              <RedirectRoute
                path="/collections/:collection"
                to="/collections/:collection"
              />
              <RedirectRoute
                path="/collections/:collectionId/bulk"
                to="/collections/:collectionId/bulk"
              />
              <RedirectRoute
                path="/products/:product"
                to="/products/:product"
              />
              <RedirectRoute path="/vendor-dashboard" to="/vendor-dashboard" />
              <RedirectRoute path="/review-publish" to="/review-publish" />
              <RedirectRoute
                path="/vendors/:vendorId/publish"
                to="/vendors/:vendorId/publish"
              />
              <RedirectRoute
                path="/vendors/:vendor/orders"
                to="/vendors/:vendor/orders"
              />
              <RedirectRoute
                path="/vendors/:vendor/orders/:orderNumber"
                to="/vendors/:vendor/orders/:orderNumber"
              />
              {/* END */}
              <Route component={PageNotFound} />
            </Switch>
          </BrowserRouter>
        </div>
      </IntlProvider>
    )
  }
}

const mapActions = { LogOut }
const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  lang: state.languageReducer.lang
})
App.propTypes = {
  authReducer: shape({
    authorized: bool,
    user: shape({
      url: string
    })
  }),
  lang: string,
  LogOut: func
}
export default withRouter(connect(mapStateToProps, mapActions)(App))
